import { REPORTS_API } from "redux/api";

const generateQueryParams = (payload) => {
    let query = "";
    if(payload?.locationId){
        query+="&locationId="+payload?.locationId
    }else if(payload?.locationid){
        query+="&locationId="+payload?.locationid
    }

    if(payload?.startDate){
        query+="&startDate="+payload?.startDate
    }
    if(payload?.endDate){
        query+="&endDate="+payload?.endDate
    }

    if(payload?.tablePageNo){
        query+="&page="+payload?.tablePageNo
    }else if(payload?.page !== undefined){
        query+="&page="+payload?.page
    }
    if(payload?.tableRecordLimit){
        query+="&size="+payload?.tableRecordLimit
    }else if(payload?.size){
        query+="&size="+payload?.size
    }
    if(payload?.searchQuery){
        query+="&search="+payload?.searchQuery
    }else if(payload?.search){
        query+="&search="+payload?.search
    }

    if(payload?.orderTypeId){
        query+=`&orderTypeId=${payload?.orderTypeId}`
    }

    if(payload?.availabilityStatus){
        query+=`&availabilityStatus=${payload?.availabilityStatus}`
    }

    if(payload?.categoryId){
        query+=`&categoryId=${payload?.categoryId}`
    }

    if(payload?.filter){
        query+=`&filter=${payload?.filter}`
    }

    if (payload?.sortBy !== undefined && payload?.sortBy !== null && payload?.sortBy !== "") {
        query += `&sortBy=${payload?.sortBy}`;
    }

    if (payload?.sortAsc !== undefined && payload?.sortAsc !== null) {
        query += `&sortAsc=${payload?.sortAsc}`;
    }

    return "?"+query?.slice(1)
}

export const getProductInsightsTopRevenue = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/top-revenue-categories${query}`,
    });
};

export const getProductInsightsTopPopular = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/popular${query}&sortOrder=${false}`,
    });
};

export const getProductInsightsTopLeastPopular = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/popular${query}&sortOrder=${true}`,
    });
};

export const getProductInsightsTopPopularRevenue = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/popular-revenue${query}&sortOrder=${false}`,
    });
};

export const getProductInsightsTopLeastPopularRevenue = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/popular-revenue${query}&sortOrder=${true}`,
    });
};

// TODO: Remove this
export const getProductInsightsTopRevenueStreams = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/top-revenue-categories${query}`,
    });
};

export const getProductInsightsCancelledItems = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/cancelled-items${query}&sortOrder=true`,
    });
};

export const getProductInsightsCancelledReasons = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/cancelled-reason${query}`,
    });
};

export const getProductInsightsItemsCancelledReasons = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/items-cancelled-reason${query}`,
    });
};

export const getProductInsightsAvailabilityByChannels = (params) => {
    // const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/available-items?locationId=${params.locationId}`,
    });
};

export const getProductAvailabilityDropDown = (params) => {
    // const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/avilability-category-names?orderTypeId=${params.orderTypeId}`,
    });
};

export const getProductInsightsAvailabilityByChannelsDetails = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/items-availability-status${query}`,
    });
};

export const getCategoryItemSales = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/category-item-sales${query}`,
    });
};

export const getCategoryItemSalesDropDown = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/product/insights/category-dropdown-details${query}`,
    });
};
